import './index.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { router } from './router.js'
import App from './App.vue'
import registerDirectives from './directives';
import registerPlugins from './plugins';

//Constants
const pinia = createPinia()
const app = createApp(App)

//Use plugins
app.use(pinia)
app.use(router)
registerPlugins(app);

// Register Directives
registerDirectives(app);

//Mount
app.mount('#app')
